import React from 'react';
import withStore from "@/hocs/withStore";
import Svg from "@/Pages/All/Svg";
import {getWeek} from "@/Helpers/Function";
import LinkLoad from "@/Layouts/LinkLoad";

function DolyameInfo({...props}) {
    const {stores = {}, config = {}} = props;
    const {modalStore = {}} = stores;
    const {paymentMethod = {}} = config;
    const {dolyame = {}} = paymentMethod;
    const {max = 0, periods = []} = dolyame;
    const period = periods[0];

    if (modalStore.installmentAmount === 0 || modalStore.installmentAmount >= max) {
        return null;
    }

    let date = new Date();
    let date1 = new Date(date.setDate(date.getDate() + 14));
    let date2 = new Date(date.setDate(date.getDate() + 14));
    let date3 = new Date(date.setDate(date.getDate() + 14));

    let dolyameSumItem, dolyameSumLast;
    dolyameSumItem = Math.floor(modalStore.installmentAmount / period);
    dolyameSumLast = modalStore.installmentAmount - dolyameSumItem * 3;

    return <div className={`modalDolyame`}>
        <Svg id={`logoDolyameTextBlack`} className={`svg__dolyameModalTextBlack`} />
        <p className={`modalDolyame__description`}>
            Оплатите 25% сейчас - остальное спишется автоматически тремя равными частями с интервалом в
            2 недели. Максимальная сумма заказа для оплаты Долями
            равна {max.toLocaleString('ru')} ₽. Возможен сервисный сбор сервиса Долями
        </p>
        {/*<div className={`modalDolyame__text`}>*/}
        {/*    <div className={`modalDolyame__text_item`}>*/}
        {/*        <Svg id={`dolyameIcon1`} className={`svg__dolyameIcon1`} />*/}
        {/*        <p>Без процентов и комиссий</p>*/}
        {/*    </div>*/}
        {/*    <div className={`modalDolyame__text_item`}>*/}
        {/*        <Svg id={`dolyameIcon2`} className={`svg__dolyameIcon2`} />*/}
        {/*        <p>Как обычная оплата картой</p>*/}
        {/*    </div>*/}
        {/*</div>*/}
        <div className={`modalDolyame__schedule`}>
            <div className={`modalDolyame__schedule_item`}>
                <p className={`date`}>Сегодня</p>
                <p className={`sum`}>{dolyameSumItem.toLocaleString('ru')} ₽</p>
                <p className={`line active`}></p>
            </div>
            <div className={`modalDolyame__schedule_item`}>
                <p className={`date`}>
                    {date1.getDate()} {getWeek(date1)}
                </p>
                <p className={`sum`}>{dolyameSumItem.toLocaleString('ru')} ₽</p>
                <p className={`line`}></p>
            </div>
            <div className={`modalDolyame__schedule_item`}>
                <p className={`date`}>
                    {date2.getDate()} {getWeek(date2)}
                </p>
                <p className={`sum`}>{dolyameSumItem.toLocaleString('ru')} ₽</p>
                <p className={`line`}></p>
            </div>
            <div className={`modalDolyame__schedule_item`}>
                <p className={`date`}>
                    {date3.getDate()} {getWeek(date3)}
                </p>
                <p className={`sum`}>{dolyameSumLast.toLocaleString('ru')} ₽</p>
                <p className={`line`}></p>
            </div>
        </div>
        <LinkLoad href={`/dolyame`} className={`btn btn__dolyameMoreInfo`}>Подробнее</LinkLoad>
    </div>
}

export default withStore(DolyameInfo)
